import { cva } from '@/styled-system/css';

export const calendarYearSelectButtonRecipe = cva({
  base: {
    // override the width and height of icon-button
    'width': 'Calendar.YearSelect.button.width!',
    'height': 'Calendar.YearSelect.button.height!',
    'padding': 0,
    'border': 'none',
    'display': 'grid',
    'placeItems': 'center',
    'position': 'absolute',
    'right': 0,
    'top': '50%',
    'transform': 'translateY(-50%)',
    'backgroundColor': { base: 'Calendar.YearSelect.bg.default' },
    'color': {
      base: 'Calendar.YearSelect.icon.default',
    },
    'pointerEvents': 'none',
    'transition': {
      _motionReduce: 'none',
      _motionSafe: 'background-color 200ms ease, box-shadow 200ms ease',
    },
    '& svg': {
      width: 'Calendar.YearSelect.icon.width',
      height: 'Calendar.YearSelect.icon.height',
    },
  },
  variants: {
    disabled: {
      true: {},
      false: {
        color: {
          _groupHover: 'Calendar.YearSelect.icon.hover',
          _pressed: 'Calendar.YearSelect.icon.pressed',
        },
        backgroundColor: {
          _groupHover: 'Calendar.YearSelect.bg.hover',
          _active: 'Calendar.YearSelect.bg.pressed',
        },
        _groupFocus: {
          boxShadow: 'inset 0 0 0 {borderWidths.Chip.default} var(--shadow-color), {shadows.focus}',
        },
      },
    },
  },
});
